import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly STORAGE_KEY = 'pp-theme';
  readonly LIGHT_THEME = 'light';
  readonly DARK_THEME = 'dark';
  readonly DEFAULT_THEME = 'dark';
  theme: string;

  get isDarkTheme(): boolean {
    return this.theme === this.DARK_THEME;
  }

  constructor() {
    this.theme = localStorage.getItem(this.STORAGE_KEY);
    this.setTheme(this.theme);

    // if store is empty get system theme
    if (this.theme == null && matchMedia && matchMedia('(prefers-color-scheme: light)').matches) {
      this.setTheme(this.LIGHT_THEME);
    } else {
      this.setTheme(this.theme || this.DEFAULT_THEME);
    }
  }

  toggleTheme(): void {
    if (this.isDarkTheme) {
      this.setTheme(this.LIGHT_THEME);
    } else {
      this.setTheme(this.DARK_THEME);
    }

    localStorage.setItem(this.STORAGE_KEY, this.theme);
  }

  setTheme(theme: string): void {
    this.theme = theme;
    document.documentElement.className = theme;
  }
}
